import React, { PropTypes, Component } from 'react'
import { FormSection } from 'redux-form'
import cx from 'classnames'
import { debounce } from 'lodash'
import { Link } from 'react-router'

import './SecondTimeBookingConfirmation.scss'
import AliadaProfileCard from 'components/AliadaProfileCard'
import Map from 'components/Map'
import AddressForm from './components/AddressForm'
import PhoneForm from './components/PhoneForm'
import PromoCodeForm from './components/PromoCodeForm'
import PaymentMethodForm from './components/PaymentMethodForm'
import ServiceSummary from './components/ServiceSummary'
import CreatingServiceLoader from './components/CreatingServiceLoader'
import MobileNavBar from 'components/MobileNavBar'
import MobileNavBarBackButton from 'components/MobileNavBarBackButton'

import { buildAddressString } from 'utils/addresses'
import { geocode } from 'utils/google-maps'
import generatePaymentTokens from '@src/services/payment'
import * as paths from 'utils/paths'
import * as localStorage from 'utils/localStorage'
import { URGENT_ALIADA_ID } from '@src/globals'

class SecondTimeBookingConfirmation extends Component {
  constructor (props) {
    super(props)

    this.onPromoCodeChange = this.onPromoCodeChange.bind(this)
    this.redeemPromoCode = this.redeemPromoCode.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.updateCoordinatesFromAddress = this.updateCoordinatesFromAddress.bind(this)
    this.onMapChange = this.onMapChange.bind(this)

    this.debounceWaitInMilliseconds = 500
    this.getCoordinatesFromAddress = debounce(
      this.getCoordinatesFromAddress,
      this.debounceWaitInMilliseconds,
      { leading: true }
    )

    const { user } = props
    this.state = {
      user: {
        hasAddress: !!user.addresses[0],
        hasCoordinates: !!(user.addresses[0] && user.addresses[0].coordinates.latitude && user.addresses[0].coordinates.longitude),
        hasPhone: !!user.phone,
        hasCreditCard: !!user.card
      },
      coordinates: {
        lat: 19.427022,
        lng: -99.167681
      }
    }

    if (this.state.user.hasCoordinates) {
      this.state.coordinates = {
        lat: parseFloat(user.addresses[0].coordinates.latitude),
        lng: parseFloat(user.addresses[0].coordinates.longitude)
      }
    }
  }

  componentDidMount () {
    const { aliada } = this.props

    if (!aliada) {
      this.fetchAliada()
    }
  }

  fetchAliada () {
    const {
      aliadaId,
      fetchAliada,
      estimatedHours
    } = this.props

    fetchAliada(aliadaId, { estimatedHours })
  }

  getPromoCode () {
    return this.props.promoCode.code || localStorage.getItem('aliada_promoCode')
  }

  onPromoCodeChange (e) {
    this.setState({
      promoCode: e.target.value
    })
  }

  redeemPromoCode ({ code }) {
    this.props.redeemPromoCode(code)
  }

  onSubmit ({ address, phone, creditCard }) {
    const serviceChanges = {}

    const {
      user: {
        hasAddress,
        hasCoordinates,
        hasPhone,
        hasCreditCard
      }
    } = this.state

    if (!hasAddress) {
      serviceChanges.address = address
    }

    if (!hasCoordinates) {
      const { lat, lng } = this.state.coordinates

      serviceChanges.address = {
        ...serviceChanges.address,
        lat,
        lng
      }
    }

    if (!hasPhone) {
      serviceChanges.user = { phone }
    }

    if (!hasCreditCard) {
      this.producePaymentTokens(creditCard)
        .then(tokens => {
          serviceChanges.paymentTokens = tokens

          this.props.updateNewService(serviceChanges)
          this.props.createService()
        })
        .catch(error => {
          this.props.displayError(error)
        })
    } else {
      this.props.updateNewService(serviceChanges)
      this.props.createService()
    }
  }

  producePaymentTokens (card) {
    generatePaymentTokens(card).then((tokens) => {
      const error = Object.keys(tokens).every((token) => {
        return tokens[token].error
      })

      if (error) {
        return Promise.reject(tokens.conekta.error.message)
      }

      tokens = Object.keys(tokens).reduce((acc, token) => {
        if (tokens[token].error) {
          return acc
        }

        acc[`${token}_temporary_token`] = tokens[token]
        return acc
      }, {})

      return tokens
    })
  }

  updateCoordinatesFromAddress (address) {
    this.getCoordinatesFromAddress(address)
      .then(coordinates => this.updateCoordinates(coordinates))
  }

  getCoordinatesFromAddress (address) {
    const addressString = buildAddressString(address)
    const coordinatesPromise = geocode(addressString)
    return coordinatesPromise
  }

  onMapChange (coordinates) {
    this.updateCoordinates(coordinates)
  }

  updateCoordinates ({ lat, lng }) {
    this.setState({
      coordinates: { lat, lng }
    })
  }

  renderAddress (address) {
    return (
      <p>
        {buildAddressString(address)}
      </p>
    )
  }

  renderPhone (phone) {
    return (
      <p>
        Tel. {phone}
      </p>
    )
  }

  renderPaymentMethod (card) {
    return (
      <div className='SecondTimeBookingConfirmation-paymentMethod'>
        <p className='SecondTimeBookingConfirmation-paymentMethodCard'>••••&nbsp;••••&nbsp;••••&nbsp;{card.last4}</p>
        <p className='SecondTimeBookingConfirmation-paymentMethodExpiration'>Fecha de expiración: <span>{card.expMonth}/{card.expYear}</span></p>
        <p>{card.name}</p>
      </div>
    )
  }

  render (props) {
    const {
      aliadaId,
      aliada,
      date,
      time,
      estimatedHours,
      serviceTypeId,
      weekdays,
      creatingService,
      redeemingPromoCode,
      promoCode,
      user,
      handleSubmit
    } = this.props

    const { user: { hasCoordinates: userHasCoordinates } } = this.state

    const { coordinates } = this.state

    const payButtonClassName = cx(
      'SecondTimeBookingConfirmation-payButton',
      'btn btn-lg btn-block btn-primary',
      {
        disabled: creatingService
      }
    )

    const userProfileUrl = paths.currentUserProfile()

    const isUrgentService = aliadaId == URGENT_ALIADA_ID

    return (
      <div className='SecondTimeBookingConfirmation'>
        <CreatingServiceLoader isOpen={creatingService} />

        <MobileNavBar
          leftControl={<MobileNavBarBackButton />}
          rightControl={
            <Link className='btn btn-default' to={userProfileUrl}>
              Mi perfil
            </Link>
          }
          >
            Agendar servicio
        </MobileNavBar>

        <form onSubmit={handleSubmit(this.onSubmit)} className='SecondTimeBookingConfirmation-form'>
          <div className='SecondTimeBookingConfirmation-card SecondTimeBookingConfirmation-serviceDetails'>
            <div className='SecondTimeBookingConfirmation-cardSection'>
              {
                aliada &&
                <AliadaProfileCard
                  aliada={aliada}
                  promoCode={promoCode}
                  estimatedServiceHours={estimatedHours}
                  avatar={{size: 120}}
                  />
              }
            </div>

            <div className='SecondTimeBookingConfirmation-cardSection'>
              <h3>Dirección y datos de contacto</h3>

              <div className='SecondTimeBookingConfirmation-contactDetails'>
                <div className='SecondTimeBookingConfirmation-contactDetailsAddressPhone'>
                  <div>
                    {
                      user.addresses[0]
                        ? this.renderAddress(user.addresses[0])
                        : <FormSection name='address'>
                          <AddressForm
                            onChange={this.updateCoordinatesFromAddress}
                            />
                        </FormSection>
                    }
                  </div>

                  <div>
                    {
                      user.phone
                        ? this.renderPhone(user.phone)
                        : <PhoneForm />
                    }
                  </div>
                </div>

                <div className='SecondTimeBookingConfirmation-contactDetailsMap'>
                  <Map
                    onChange={this.onMapChange}
                    location={coordinates}
                    draggable={!userHasCoordinates}
                    />
                </div>
              </div>
            </div>

            <div className='SecondTimeBookingConfirmation-cardSection'>
              <h3>Código de promoción</h3>

              <PromoCodeForm
                initialValues={{
                  code: this.getPromoCode()
                }}
                disabled={redeemingPromoCode || creatingService}
                />
            </div>

            <div className='SecondTimeBookingConfirmation-cardSection'>
              <h3>Método de Pago</h3>
              {
                user.card
                  ? this.renderPaymentMethod(user.card)
                  : <FormSection name='creditCard'>
                    <PaymentMethodForm />
                  </FormSection>
              }
            </div>
          </div>

          <div className='SecondTimeBookingConfirmation-card SecondTimeBookingConfirmation-serviceSummary'>
            <ServiceSummary
              date={date}
              time={time}
              estimatedHours={estimatedHours}
              promoCode={promoCode}
              serviceTypeId={serviceTypeId}
              weekdays={weekdays}
              urgent={isUrgentService}
              />

            <div className='SecondTimeBookingConfirmation-cardSection'>
              <button
                className={payButtonClassName}
                type='submit'
                disabled={redeemingPromoCode || creatingService}
                >
                {isUrgentService ? 'Confirmar servicio' : 'Pagar ahora'}
              </button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

SecondTimeBookingConfirmation.displayName = 'SecondTimeBookingConfirmation'
SecondTimeBookingConfirmation.propTypes = {
  userId: PropTypes.number.isRequired,
  user: PropTypes.object.isRequired,
  isFirstService: PropTypes.bool,
  aliadaId: PropTypes.number.isRequired,
  aliada: PropTypes.object,
  date: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  estimatedHours: PropTypes.number.isRequired,
  serviceTypeId: PropTypes.string.isRequired,
  promoCode: PropTypes.object.isRequired,
  redeemingPromoCode: PropTypes.bool,
  creatingService: PropTypes.bool,

  fetchAliada: PropTypes.func.isRequired,
  redeemPromoCode: PropTypes.func.isRequired,
  createService: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired
}
SecondTimeBookingConfirmation.defaultProps = {}

export default SecondTimeBookingConfirmation



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/SecondTimeBookingConfirmation/SecondTimeBookingConfirmation.js